// frontend/src/AppRoleSwitch.tsx
import React from "react";
import KitchenQueue from "./screens/KitchenQueue";
import BarQueue from "./screens/BarQueue";
import PosRegister from "./PosRegister"; // zadrži putanju kao u tvom projektu
import TVQueue from "./screens/TVQueue";
import Kiosk from "./screens/Kiosk";

function getRoleSafe(): string | null {
  try {
    // pokušaj nekoliko tipičnih ključeva koje tvoj login već koristi
    //get localStorage value device.isTv or device.isKitchen or device.isWaiter or device.isCashier
    const cands = ["pos.employee"];
    const isTv = localStorage.getItem("device.isTv");
    const isKitchen = localStorage.getItem("device.isKitchen");
    const isWaiter = localStorage.getItem("device.isWaiter");
    const isCashier = localStorage.getItem("device.isCashier");
    const isKiosk = localStorage.getItem("device.isKiosk");
    if (isKiosk === "1" || isKiosk === "true") return "kiosk";
    if (isTv === "1" || isTv === "true") return "tv";
    if (isKitchen === "1" || isKitchen === "true") return "kitchen";
    if (isWaiter === "1" || isWaiter === "true") return "waiter";
    if (isCashier === "1" || isCashier === "true") return "cashier";
    if (localStorage.getItem("device.isBar")) return "cashier"; // bar je isto što i cashier
    if (localStorage.getItem("device.isKiosk")) return "kiosk"; // kiosk je isto što i cashier
    // ako nijedan od ovih nije postavljen, pokušaj dohvatiti role iz pos.employee

    for (const k of cands) {
      const raw = localStorage.getItem(k);
      if (!raw) continue;
      const obj = JSON.parse(raw);
      const role = obj?.role || obj?.data?.role || obj?.user?.role;
      if (role) return String(role);
    }
  } catch {}
  return null;
}

export default function AppRoleSwitch() {
  const role = getRoleSafe();

  if (role === "kitchen") return <KitchenQueue />;
  if (role === "waiter" || role === "cashier") return <BarQueue />;
  if (role === "tv") return <TVQueue />;
  if (role === "kiosk") return <Kiosk />;

  // default – tvoj postojeći POS ekran
  return <PosRegister />;
}
